module.exports = __webpack_public_path__ + "assets/media/day23.ae60406f.mp3";